(function (root, factory) {
  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (root) root.ConsoleModderProduct = api;
  if (root && root.document) {
    var mount = function () {
      root.document.querySelectorAll("[data-product-section]").forEach(api.init);
    };
    if (root.document.readyState === "loading") {
      root.document.addEventListener("DOMContentLoaded", mount, { once: true });
    } else {
      mount();
    }
    root.document.addEventListener("shopify:section:load", mount);
  }
})(typeof window !== "undefined" ? window : globalThis, function () {
  "use strict";

  function applyVariant(variant, view) {
    if (!variant) return false;
    view.price.textContent = variant.price;
    if (view.comparePrice) {
      view.comparePrice.textContent = variant.compareAtPrice || "";
      view.comparePrice.hidden = !variant.compareAtPrice;
    }
    view.availability.textContent = variant.available
      ? "Available according to the Shopify listing"
      : "Currently unavailable";
    view.submit.disabled = !variant.available;
    view.submit.textContent = variant.available ? "Add to cart" : "Unavailable";
    return true;
  }

  function init(section) {
    if (!section || section.dataset.productReady === "true") return;
    var data = section.querySelector("[data-product-variants]");
    var select = section.querySelector("[data-product-variant]");
    var price = section.querySelector("[data-product-price]");
    var comparePrice = section.querySelector("[data-product-compare-price]");
    var availability = section.querySelector("[data-product-availability]");
    var submit = section.querySelector("[data-product-submit]");
    if (!data || !select || !price || !availability || !submit) return;

    var variants;
    try {
      variants = JSON.parse(data.textContent || "[]");
    } catch (_error) {
      return;
    }
    if (!Array.isArray(variants)) return;
    section.dataset.productReady = "true";

    function update() {
      var variant = variants.find(function (item) {
        return String(item.id) === String(select.value);
      });
      applyVariant(variant, {
        price: price,
        comparePrice: comparePrice,
        availability: availability,
        submit: submit
      });
    }

    select.addEventListener("change", update);
    update();
  }

  return { applyVariant: applyVariant, init: init };
});
